export default __webpack_public_path__ + "4508141d6679104b8be226a5c5238341.svg";